import Container from './Container';

// export types
export type { ContainerProps } from './Container';

// export components
export { Container };
export default Container;
